module.exports = __webpack_public_path__ + "img/full4-min.a788cc74.png";